import * as stylex from "@stylexjs/stylex";
import { colors, spacing } from "@softmax/design-system/tokens.stylex";
import { ExternalMark, externalLinkProps } from "@softmax/web-ux/shell";
import { SidebarIcon } from "./sidebar-icon";
import { sidebarLinkStyles } from "./sidebar-link.styles";

export function SidebarOwnerLinks({
  links,
}: {
  readonly links: readonly { readonly label: string; readonly href: string }[];
}) {
  return (
    <div {...stylex.props(styles.ownerLinks)}>
      {links.map((link) => (
        <a
          key={link.href}
          href={link.href}
          {...externalLinkProps}
          {...stylex.props(sidebarLinkStyles.row, sidebarLinkStyles.resting)}
        >
          <SidebarIcon name="external" />
          <span>
            {link.label}
            <ExternalMark />
          </span>
        </a>
      ))}
    </div>
  );
}

const styles = stylex.create({
  ownerLinks: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    marginTop: spacing.space8,
    paddingTop: spacing.space8,
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: colors.border,
  },
});
